<template>
  <div>
    <div class="card">
        <header class="header-card">
          <p>{{ $t('paramInterneAdmin.gestionInterface.message.title')}}</p>
        </header>
        <div class="card-content">
            <div class="is-pulled-right mb-4">
                <button class="button is-addOrEdit" @click="createMessage()">
                    {{ $t('paramInterneAdmin.gestionInterface.message.ajouter') }}
                </button>
            </div>
          <v-server-table
            ref="messageTable"
            :columns="columns"
            :options="options"
            @loaded="finLoading"
            @loading="debutLoading">
            <template v-slot:message="{ row }">
                <div v-html="row.message"></div>
            </template>
            <template v-slot:dateDebutAffichage="{ row }">
                {{ formatDate(row.dateDebutAffichage) }}
            </template>
            <template v-slot:dateFinAffichage="{ row }">
                {{ formatDate(row.dateFinAffichage) }}
            </template>
            <template v-slot:visibleUniquement="{ row }">
                <qd-checkbox v-model="row.visibleUniquement" :disabled="true" />
            </template>
            <template v-slot:edit="{ row }">
                <btn-action-icon
                    :tooltip-label="$t('general.button.edit')"
                    :permission="GENERAL.maj"
                    @is-click="editMessage(row)"
                    icon-type="is-success"
                    icon="pencil-box-outline">
                </btn-action-icon>
            </template>
            <template v-slot:delete="{ row }">
              <delete-list-button
                :query="() => remove(row.id)"
                :permissions="GENERAL.maj"
                validation="validation"
                :title="$t('paramInterneAdmin.gestionInterface.message.supprimerMessage.delete')"
                :subtitle="$t
               ('paramInterneAdmin.gestionInterface.message.supprimerMessage.irreversible')"
                :successMessage="$t('paramInterneAdmin.gestionInterface.message.deleteSuccess')"
                    @done="recherche()"
                />
            </template>
          </v-server-table>
        </div>
    </div>
    <div class="card mgt-20px">
        <header class="header-card">
          <p>{{ $t('paramInterneAdmin.gestionInterface.imageConnexion.title')}}</p>
        </header>
        <div class="card-content">
          <div class="is-pulled-left mb-4">
            <b-field>
              <b-select
                v-model="projetName"
                @change.native="loadImage">
                <option
                  v-for="item in constantes.LISTE_PROJET_NAME"
                  :value="item.code"
                  :key="item.code">
                  {{ $t(`paramInterneAdmin.gestionInterface.imageConnexion.projets.${item.code}`) }}
                </option>
              </b-select>
            </b-field>
          </div>
            <div class="is-pulled-right mb-4 is-flex">
              <uploader
                @added="addImage"
                @filePrevented="filePrevented"
                :extensions="/\.(gif|jpe?g|png|webp|bmp)$/i"
                accept="image/*"
                name="uploader-image-connexion"
                :size="TAILLE_PJ_LIMITE">
                <div class="button is-addOrEdit">
                    {{ $t('paramInterneAdmin.gestionInterface.imageConnexion.modifier') }}
                </div>
              </uploader>
              <button
                class="button is-danger mgl-2"
                :disabled="!imageUrl"
                :class="{ 'button-access-no-permission': !imageUrl }"
                @click="() => popUpDelete = true">
                    {{ $t('paramInterneAdmin.gestionInterface.imageConnexion.supprimer') }}
                </button>
            </div>
            <img
              class="width-100percent"
              :src="imageConnexion" />
        </div>
    </div>
    <b-modal
      class="modal"
      width="600px"
      :active="popupEdition"
      has-modal-card
      @close="popupEdition = false">
        <p-edition-message-acceuil
            v-if="targetMessage"
            :message="targetMessage"
            @recherche="recherche"/>
    </b-modal>
    <b-modal v-model="popUpDelete" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('paramInterneAdmin.gestionInterface.imageConnexion.popUp.supprimer')"
        :messFooter="$t('paramInterneAdmin.gestionInterface.imageConnexion.popUp.irreversible')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :is-error-popup="errorPopUp"
        :messages-popup="messagesPopup"
        @yes="supprimerImage"
        @no="popUpDelete = false">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>
import {
  NO_PAGINATION,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import formatDate from '@/services/general/formatDate';
import { GENERAL } from '@/configuration/general/permissionsParametrageConf';
import btnActionIcon from '@/components/general/btnActionIcon';
import pEditionMessageAcceuil from '@/components/configInterne/messageAcceuil/p_editionMessageAcceuil';
import cloneDeep from 'lodash/cloneDeep';
import gestionDateBase from '@/services/general/gestionDateBase';
import { getAll, remove } from '@/api/messageAcceuil';
import deleteListButton from '@/components/general/button/deleteListButton';
import validation from '@/services/validation/validation';
import uploader from '@/components/general/uploader';
import messageErreur from '@/services/general/messageErreur';
import messageInformation from '@/services/general/messageInformation';
import { PIECE_JOINTE_TYPE_LOGO } from '@/configuration/general/pieceJointeConf';
import updateImage from '@/services/piecesJointes/imageConnexion';
import genererGuid from '@/services/general/genererGuid';
import { deleteImage, getImageConnexion } from '@/api/imageConnexion';
import { TAILLE_PJ_LIMITE } from '@/configuration/piecesJointes';
import popUpPrevention from '@/components/general/popUpPrevention';
import { PROJET_NAME_BODAC, LISTE_PROJET_NAME } from '@/configuration/imageConnexion';

export default {
  data() {
    return {
      loadingComponent: null,
      formatDate,
      GENERAL,
      targetMessage: null,
      popupEdition: false,
      remove,
      validation,
      TAILLE_PJ_LIMITE,
      imageUrl: null,
      popUpDelete: false,
      errorPopUp: false,
      messagesPopup: [],
      projetName: PROJET_NAME_BODAC,
      constantes: {
        LISTE_PROJET_NAME,
      },
    };
  },
  components: {
    btnActionIcon,
    pEditionMessageAcceuil,
    deleteListButton,
    uploader,
    popUpPrevention,
  },
  computed: {
    columns() {
      return ['message', 'dateDebutAffichage', 'dateFinAffichage', 'visibleUniquement', 'edit', 'delete'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          message: this.$i18n.t('paramInterneAdmin.gestionInterface.message.tabs.message'),
          dateDebutAffichage: this.$i18n.t('paramInterneAdmin.gestionInterface.message.tabs.dateDebutAffichage'),
          dateFinAffichage: this.$i18n.t('paramInterneAdmin.gestionInterface.message.tabs.dateFinAffichage'),
          visibleUniquement: this.$i18n.t('paramInterneAdmin.gestionInterface.message.tabs.visibleUniquement'),
          edit: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: TEXTS,
        sortable: [],
        columnsClasses: {
          edit: 'colonneSelected',
          delete: 'colonneSelected',
        },
        requestFunction: (() => {
          const paylaod = {
            query: {},
            limit: NO_PAGINATION,
          };
          return getAll(paylaod);
        }),
        responseAdapter: (response) => {
          return {
            count: response.data.result.totalCount,
            data: response.data.result.items,
          };
        },
      };
    },
    imageConnexion() {
      return this.imageUrl ?? '/static/img/default-placeholder.png';
    },
  },
  methods: {
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    async recherche() {
      await this.$refs.messageTable.refresh();
    },
    genererMessage() {
      return {
        message: '',
        dateDebutAffichage: null,
        dateFinAffichage: null,
        visibleUniquement: false,
      };
    },
    createMessage() {
      this.targetMessage = this.genererMessage();
      this.popupEdition = true;
    },
    editMessage(row) {
      const updateMessage = cloneDeep(row);
      updateMessage.dateDebutAffichage = gestionDateBase(updateMessage.dateDebutAffichage);
      updateMessage.dateFinAffichage = gestionDateBase(updateMessage.dateFinAffichage);
      this.targetMessage = updateMessage;
      this.popupEdition = true;
    },
    filePrevented(error) {
      messageInformation(error.message, 'is-danger');
    },
    async addImage(file) {
      if (!file) return;
      const loadingComponent = this.$buefy.loading.open();
      const formatedFile = {
        ...file,
        nom: file.name,
        placeType: PIECE_JOINTE_TYPE_LOGO,
        id: genererGuid(),
        projetName: this.projetName,
      };
      delete formatedFile.type;
      try {
        await updateImage(formatedFile);
        await this.loadImage();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async supprimerImage() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteImage(this.projetName);
        this.popUpDelete = false;
        await this.loadImage();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async loadImage() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const image = (await getImageConnexion(this.projetName))?.data?.result;
        this.imageUrl = image?.chemin;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    await this.loadImage();
  },
};
</script>

<style>

</style>
